import yup from "src/utils/yup/extensionMethods";
import { bindTypes } from "./interface";

export const deleteSchema = (translate: Function) => yup.object().shape({
	wda002Titulo: yup.string()
		.required(translate("Titulo do relatório não confere"))
		.oneOf([yup.ref("wda002TituloConfirmation")], translate("Titulo do relatório não confere"))
});

export const addAndChangeSchema = (translate:Function) => yup.object().shape(
	{
		wda002Titulo: yup.string()
			.required(translate("Título é requerido")),
		wda002Sqlquery:yup.string()
			.required(translate("Campo sql é obrigatório")),
		columns:yup.array()
			.of(wdtba003Schema(translate)),
		binds:yup.array()
			.of(wdtba009Schema(translate))
	}
);

const wdtba003Schema = (translate:Function) => yup.object().shape({
	wda003Nomecoluna:yup.string()
		.required(translate("Nome é requerido")),
	wda003Tipocoluna:yup.string()
		.required(translate("Tipo é requerido")),
	wda003Label:yup.string()
		.required(translate("Label é requerido")),
	rules:yup.array()
		.of(wdtba011Schema(translate))
});

const wdtba009Schema = (translate:Function) => yup.object().shape({
	wda009Tipo:yup.string()
		.required(translate("Tipo é requerido")),
	wda009Bind:yup.string()
		.required(translate("Nome é requerido")),
	wda009Sqllov:yup.string()
		.when("wda009Tipo",(type,schema) => 
			type === bindTypes.lOV ? 
				schema.required(translate("Campo de sql é obrigatório")):schema),
	wda009Label:yup.string()
		.required(translate("Label é requerido")),
	wda009Valordefault:yup.string(),
	wda009Ordem:yup.number(),
	options:yup.array()
		.of(wdtba010Schema(translate))
		.when("wda009Tipo",(type,schema) => 
			type === bindTypes.OPTIONS_LIST ? 
				schema.required(translate("Lista de opções é obrigatória"))
					.min(1,translate("Ao menos uma opção deve ser informado"))
					.unique(translate("Valores das opções não podem ser repetidas"), (a: any) => a.wda010Valor)
				:schema)
});

const wdtba010Schema = (translate:Function) => yup.object().shape({
	wda010Descricao:yup.string()
		.required(translate("Descrição da opção é requerida")), 
	wda010Valor:yup.string()
		.required(translate("Valor é requerido"))     
});

const wdtba011Schema = (translate:Function) => yup.object().shape({
	wda011Operador:yup.string()
		.required(translate("Operador é requerido")),
	wda011Valor:yup.string()
		.when("wda011Operador",(operator,schema) => 
			operator !== "9" && operator !== "13" ? 
				schema.required(translate("Valor é requerido")):schema),
	wda011Valorfim:yup.string()
		.when("wda011Operador",(operator,schema) => 
			operator === "7"||operator === "11" ? 
				schema.required(translate("Valor final é requerido")):schema)
});

export const rulesSchema = (translate:Function) => yup.array().of(wdtba011Schema(translate));
